import React from 'react';
import RecoveriesDisplay from 'components/LM/Logs/Recoveries/RecoveriesDisplay';
import { useLocation } from 'react-router-dom';

function LogsRecoveries() {
	const search = useLocation().search;
	const type = new URLSearchParams(search).get('type');

	return <RecoveriesDisplay type={type} />
}

export default LogsRecoveries;
